import React, { Component } from "react";
import { CallAPI, HandleTextChange, HandleSelectChange, parseIntFromStr, GetCookieFunction } from '../../../utils/util';
import Alert from 'react-bootstrap/Alert';
import { PatientNav } from '../../patients/patientnav';
import { FunnelNav } from '../../patients/funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import VoiceInput from '../../../utils/VoiceInput';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

// Dialysis orders are unique to patients

class DialysisOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "rows": {},
            "patientID": parseIntFromStr(this.props.router.params.patientId),
            "doctorID": GetCookieFunction("User").id,
            "modalVariant": "",
            "modalMessage": ""
        };

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
    };

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/dialysisOrder`, 'GET', (res) => {
            var orders = undefined;
            if (!res){
                console.log("No results found");
                orders = { Frequency: "3", Duration: "240" };
            } else {
                orders = res;
                // Apply defaults for fields that come back as 0 (never set)
                if (!orders.Frequency) orders.Frequency = "3";
                if (!orders.Duration) orders.Duration = "240";
            }
            this.setState({"rows": orders})
        }, () => {
            // No dialysis order exists yet — initialize with defaults
            this.setState({"rows": { Frequency: "3", Duration: "240" }});
        });
    }

    // TODO: Put in correct api name
    handleSubmit(event) {
        event.preventDefault();

        CallAPI(
            {
                "rows": this.state.rows, 
                "patientID": this.state.patientID,
                "doctorID": this.state.doctorID
            }, 
            `patients/${this.state.patientID}/dialysisOrder`, 'PUT', (res) => {
                if (this.funnel){
                    this.props.router.navigate("/patients/" + this.state.patientID + "/profile");
                } else {
                    this.setState({
                        "modalVariant": "success",
                        "modalMessage": "Patient dialysis order has been saved."
                    });
                }
            },
            (message) => {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "Order information could not be saved."
                })
            }
        );
    };

    render = () => {
        const r = this.state.rows;
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.state.patientID} currentStep={9} />}                    <div className="ci-header">
                        <h2>Dialysis Order</h2>
                        <p>Set treatment parameters for this patient</p>
                    </div>
                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                    )}
                    <form onSubmit={(e) => this.handleSubmit(e)}>

                        <div className="ci-section-title">Treatment Parameters</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="Frequency" className="ci-required-label">Frequency (times/week)</label>
                                    <input type="text" id="Frequency" name="Frequency" required
                                        pattern="^\d$" maxLength="1" title="Single digit number"
                                        placeholder="e.g. 3"
                                        value={r.Frequency || "3"}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_Duration" className="ci-required-label">Duration (minutes)</label>
                                    <input type="text" id="do_Duration" name="Duration" required
                                        pattern="^\d{1,3}$" maxLength="3" title="Number of minutes"
                                        placeholder="e.g. 240"
                                        value={r.Duration || "240"}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_bfr" className="ci-required-label">Blood Flow Rate (mL/min)</label>
                                    <input type="text" id="do_bfr" name="Blood_Flow" required
                                        pattern="^\d{1,3}$" maxLength="3"
                                        placeholder="e.g. 300"
                                        value={r.Blood_Flow || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_DryWeight" className="ci-required-label">Dry Weight (kg)</label>
                                    <input type="text" id="do_DryWeight" name="Dry_Weight" required
                                        pattern="^\d{1,3}(\.\d{0,2})?$" maxLength="6"
                                        title="e.g. 65 or 65.5"
                                        placeholder="e.g. 65.5"
                                        value={r.Dry_Weight || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_dfr" className="ci-required-label">Dialysate Flow Rate (mL/min)</label>
                                    <input type="text" id="do_dfr" name="Dialysate_Flow" required
                                        pattern="^\d{1,3}$" maxLength="3"
                                        placeholder="e.g. 500"
                                        value={r.Dialysate_Flow || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="sDialyzer" className="ci-required-label">Dialyzer Type</label>
                                    <select id="sDialyzer" name="Dialyzer_Type" required
                                        value={r.Dialyzer_Type || "NONE"}
                                        onChange={(e) => this.handleSelectChange(e, "rows")}>
                                        <option value="NONE">None</option>
                                        <option value="SINGLE_USE">Single Use</option>
                                        <option value="MULTIPLE_USE">Multiple Use</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="ci-section-title">Electrolytes (mEq/L)</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="do_sodium">Sodium</label>
                                    <input type="text" id="do_sodium" name="Sodium"
                                        pattern="^\d{1,3}(\.\d{1,2})?$" maxLength="6"
                                        placeholder="e.g. 138.0"
                                        value={r.Sodium || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_potassium">Potassium</label>
                                    <input type="text" id="do_potassium" name="Potassium"
                                        pattern="^\d{1,3}(\.\d{1,2})?$" maxLength="6"
                                        placeholder="e.g. 2.0"
                                        value={r.Potassium || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_calcium">Calcium</label>
                                    <input type="text" id="do_calcium" name="Calcium"
                                        pattern="^\d{1,3}(\.\d{1,2})?$" maxLength="6"
                                        placeholder="e.g. 1.5"
                                        value={r.Calcium || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="do_bicarbonate">Bicarbonate</label>
                                    <input type="text" id="do_bicarbonate" name="Bicarbonate"
                                        pattern="^\d{1,3}(\.\d{1,2})?$" maxLength="6"
                                        placeholder="e.g. 35.0"
                                        value={r.Bicarbonate || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-section-title">Notes</div>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="txtComments">Comments</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="txtComments" name="Comments" maxLength="512" rows={3}
                                        placeholder="Additional notes or instructions..."
                                        value={r.Comments || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            rows: { ...prev.rows, Comments: (prev.rows.Comments || "") + (prev.rows.Comments ? " " : "") + text }
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Order</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };
}

export default withRouter(DialysisOrder)